import React from 'react';
import { useQuery } from '@apollo/client';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { SubscriptionTab } from '@css-xp/base/common-tabs';
import { fetchSubscriptionsForShipToParty } from './queries/fetch-subscriptions-for-ship-to-party';
import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';

interface SubscriptionTabIgProps {
  shipToPartyId?: string;
  label?: string;
}

export const SubscriptionTableForShipToParty = ({ shipToPartyId, label }: SubscriptionTabIgProps) => {
  const { data, loading, error, refetch } = useQuery<
    generatedTypesNew.FetchSubscriptionsForShipToPartyQuery,
    generatedTypesNew.FetchSubscriptionsForShipToPartyQueryVariables
  >(fetchSubscriptionsForShipToParty, {
    variables: {
      id: shipToPartyId ?? '',
      searchOptions: { first: DEFAULT_ROWS_PER_PAGE },
    },
    skip: !shipToPartyId,
    nextFetchPolicy: 'cache-and-network',
  });

  const nodes = data?.invoiceGroupsForShipToPartyId?.productSubscriptions?.nodes;
  const totalCount = data?.invoiceGroupsForShipToPartyId?.productSubscriptions?.totalCount ?? 0;

  return (
    <SubscriptionTab
      nodes={nodes}
      totalRecords={totalCount}
      loading={loading}
      error={error}
      refetch={refetch}
      label={label}
      isShipToPartySidebar={true}
    />
  );
};
